export const GET_PARTICIPANTS = 'GET_PARTICIPANTS';
export const SET_CURRENT_PARTICIPANT = 'SET_CURRENT_PARTICIPANT';
export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
export const SET_BILLING_DETAIL = 'SET_BILLING_DETAIL';
export const SET_ENEDIS_DETAIL = 'SET_ENEDIS_DETAIL';
export const SET_DSO_DETAILS = 'SET_DSO_DETAILS';
export const UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS = 'UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS';
export const UPDATE_CURRENT_PARTICIPANT_ENEDIS_DETAIL =  'UPDATE_CURRENT_PARTICIPANT_ENEDIS_DETAIL';
export const UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL = 'UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL';
